import React from 'react'
import {useParams} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header';
import Credit from '../components/creditSection';


export default function Customercredits() {

  const {email} = useParams();
  return (
    <>
      <InactivityLogout>
      <Header searchterm={email} />
      <Credit searchterm={email} />
      </InactivityLogout>
    </>
  )
}
